import {combineReducers} from "redux";

import tabsReducer from "../components/tabs/tabsReducer";
import tabsReducer2 from "../components/tabs/tabsReducer2";

const rootReducer = combineReducers({
    tabs : tabsReducer, tabs2: tabsReducer2
});

export default rootReducer;